module.exports = __webpack_public_path__ + "static/media/pin_buckle_titanium.cb1f2a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_buckle_titanium.png
// module id = 109
// module chunks = 0